module.exports = __webpack_public_path__ + "images/84da5aaee7f593340c13ca053775e0f8-outdoor_camera_green.svg";